interface Course {
  title: string;
  duration: string;
  modules: number;
  price: string;
  description: string;
  topics: string[];
}

export const courses: Course[] = [
  {
    title: "College właściciela szkoły 2.0 stopień 1",
    duration: "4h",
    modules: 17,
    price: "749 zł",
    description: "Podstawy prowadzenia szkoły językowej, aspekty prawne i finansowe",
    topics: [
      "Podstawy prawne prowadzenia szkoły językowej",
      "Modele biznesowe w edukacji językowej",
      "Planowanie finansowe i budżetowanie",
      "Systemy zarządzania szkołą",
      "Tworzenie oferty kursów"
    ]
  },
  {
    title: "College właściciela szkoły 2.0 stopień 2",
    duration: "3:36h",
    modules: 16,
    price: "749 zł",
    description: "Zaawansowane strategie rozwoju szkoły językowej",
    topics: [
      "Optymalizacja procesów biznesowych",
      "Zarządzanie zespołem lektorów",
      "Strategie rozwoju i skalowania",
      "Analiza finansowa i optymalizacja kosztów",
      "Budowanie długoterminowej strategii"
    ]
  },
  {
    title: "Dochodowe półkolonie",
    duration: "4h",
    modules: 12,
    price: "549 zł",
    description: "Kompleksowy kurs organizacji dochodowych półkolonii językowych",
    topics: [
      "Planowanie półkolonii językowych",
      "Kalkulacja kosztów i cen",
      "Marketing i promocja",
      "Organizacja i logistyka",
      "Programy zajęć i materiały"
    ]
  },
  {
    title: "Zdrowe finanse szkoły",
    duration: "1:24h",
    modules: 10,
    price: "197 zł",
    description: "Kompleksowy kurs zarządzania finansami szkoły językowej",
    topics: [
      "Podstawy zarządzania finansami szkoły",
      "Optymalizacja kosztów operacyjnych",
      "Planowanie budżetu i prognozowanie",
      "Analiza rentowności kursów",
      "Strategie cenowe i pakiety usług"
    ]
  },
  {
    title: "Od fana do klienta w Social Mediach",
    duration: "4:49h",
    modules: 18,
    price: "549 zł",
    description: "Kompleksowy kurs budowania skutecznej obecności w mediach społecznościowych",
    topics: [
      "Strategia obecności w social mediach",
      "Budowanie zaangażowanej społeczności",
      "Tworzenie angażujących treści",
      "Konwersja obserwujących w klientów",
      "Analityka i optymalizacja działań"
    ]
  },
  {
    title: "Podkręć swoją produktywność",
    duration: "3:15h",
    modules: 29,
    price: "349 zł",
    description: "Zwiększ swoją efektywność i lepiej zarządzaj czasem",
    topics: [
      "Techniki zarządzania czasem",
      "Organizacja pracy własnej i zespołu",
      "Narzędzia zwiększające produktywność",
      "Delegowanie zadań i odpowiedzialności",
      "Eliminacja rozpraszaczy i prokrastynacji"
    ]
  },
  {
    title: "Canva - twórz swoje autorskie materiały",
    duration: "4:46h",
    modules: 21,
    price: "197 zł",
    description: "Naucz się tworzyć profesjonalne materiały marketingowe i edukacyjne",
    topics: [
      "Podstawy pracy w Canva",
      "Projektowanie materiałów edukacyjnych",
      "Tworzenie grafik na social media",
      "Spójny branding szkoły",
      "Szablony i automatyzacja pracy"
    ]
  },
  {
    title: "Dochodowy edubiznes online",
    duration: "5h",
    modules: 15,
    price: "990 zł",
    description: "Kompleksowy kurs budowania dochodowego biznesu edukacyjnego online",
    topics: [
      "Model biznesowy online",
      "Tworzenie oferty kursów",
      "Marketing i sprzedaż online",
      "Automatyzacja procesów",
      "Skalowanie biznesu"
    ]
  },
  {
    title: "Puzzle biznesu online",
    duration: "2:18h",
    modules: 10,
    price: "197 zł",
    description: "Podstawy budowania biznesu edukacyjnego online",
    topics: [
      "Fundamenty biznesu online",
      "Tworzenie oferty",
      "Podstawy marketingu",
      "Systemy sprzedaży",
      "Pierwsze kroki w e-learningu"
    ]
  },
  {
    title: "5 nagrań ze szkoleń rozwiń szkołę",
    duration: "6:13h",
    modules: 5,
    price: "390 zł",
    description: "Zbiór praktycznych szkoleń dla właścicieli szkół językowych",
    topics: [
      "Rozwój szkoły językowej",
      "Optymalizacja procesów",
      "Marketing i sprzedaż",
      "Zarządzanie zespołem",
      "Finanse i rentowność"
    ]
  },
  {
    title: "Marketing w szkole stacjonarnej",
    duration: "3:34h",
    modules: 12,
    price: "497 zł",
    description: "Strategie marketingowe dla szkół stacjonarnych",
    topics: [
      "Marketing lokalny",
      "Budowanie marki",
      "Pozyskiwanie klientów",
      "Kampanie reklamowe",
      "Analiza skuteczności działań"
    ]
  },
  {
    title: "Skuteczna reklama na Facebooku",
    duration: "5:22h",
    modules: 38,
    price: "547 zł",
    description: "Kompleksowy kurs reklamy na Facebooku dla szkół językowych",
    topics: [
      "Podstawy reklamy na FB",
      "Targetowanie reklam",
      "Tworzenie kampanii",
      "Optymalizacja budżetu",
      "Analiza wyników"
    ]
  },
  {
    title: "Strategia działań w social mediach",
    duration: "1:47h",
    modules: 20,
    price: "497 zł",
    description: "Kompleksowy kurs budowania skutecznej strategii w mediach społecznościowych",
    topics: [
      "Planowanie strategii social media",
      "Tworzenie contentu",
      "Budowanie zasięgów",
      "Analiza wyników",
      "Optymalizacja działań"
    ]
  },
  {
    title: "Menadżer na dobrych torach - Zarządzanie na wyższym poziomie",
    duration: "10:18h",
    modules: 9,
    price: "1547 zł",
    description: "Zaawansowany kurs zarządzania dla managerów szkół językowych",
    topics: [
      "Strategiczne zarządzanie szkołą",
      "Rozwój zespołu",
      "Optymalizacja procesów",
      "Zarządzanie zmianą",
      "Budowanie kultury organizacyjnej"
    ]
  }
] as const;